import {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {Link} from 'react-router-dom';

import {classNames} from 'primereact/utils';
import {StyleClass} from 'primereact/styleclass';
import {useDialogCrup} from '@iamsoftware/react-hooks';

import {AppTopbarRef} from 'src/types/types';
import {LayoutContext} from 'src/layout/context/layoutcontext';

import {AuthService} from 'src/service/AuthService';
import {AppStorage} from '../service/UserStorage';

const AppTopbar = forwardRef<AppTopbarRef>((props, ref) => {

  const { layoutState, onMenuToggle, showProfileSidebar} = useContext(LayoutContext);

  const menubuttonRef = useRef(null);
  const topbarmenuRef = useRef(null);
  const topbarmenubuttonRef = useRef(null);
  const accountRef = useRef(null);

  useImperativeHandle(ref, () => ({
    menubutton: menubuttonRef.current,
    topbarmenu: topbarmenuRef.current,
    topbarmenubutton: topbarmenubuttonRef.current
  }));

  const logout = () => {
    AuthService.logout().then(() => {
      window.location.hash = '/login';
    });
  }


  const {render: renderDialogChangePassword, create: changePassword} = useDialogCrup({
    header: '!Đổi mật khẩu',
    width: '40rem',
    fields: [
      {field: 'oldPassword', header: 'Mật khẩu cũ', required: true, type: 'Password', className: 'md:col-12'},
      {field: 'newPassword', header: 'Mật khẩu mới', required: true, type: 'Password', className: 'md:col-12'},
      {field: 'newPasswordVerify', header: 'Nhập lại mật khẩu mới', required: true, type: 'Password', className: 'md:col-12'}
    ],
    createItem: item => {
      return AuthService.changePassword(item);
    },
    checkResponseError: data => {
      let error = '';
      if (data?.isSuccess === 'N') {
        error = data.messages;
      }
      return error;
    },
    useSaveSplitButton: false
  });

  return (
    <div className="layout-topbar">
      <Link to="/dashboard" className="layout-topbar-logo">
        <img src="/iam/iam-econtract.png" alt="IAM-ECONTRACT" style={{height: '2.4rem'}}/>
      </Link>

      <button ref={menubuttonRef} type="button" className="p-link layout-menu-button layout-topbar-button" onClick={onMenuToggle}>
        <i className="pi pi-bars"/>
      </button>

      <button ref={topbarmenubuttonRef} type="button" className="p-link layout-topbar-menu-button layout-topbar-button" onClick={showProfileSidebar}>
        <i className="pi pi-ellipsis-v"/>
      </button>

      <div ref={topbarmenuRef} className={classNames('layout-topbar-menu', {'layout-topbar-menu-mobile-active': layoutState.profileSidebarVisible})}>
        <div className="house-holds">
        </div>

        <div className="topbar-profile">
          <StyleClass nodeRef={accountRef} selector="@next" enterClassName="hidden" enterActiveClassName="scalein" leaveToClassName="hidden" leaveActiveClassName="fadeout" hideOnOutsideClick>
            <button ref={accountRef} className="p-link layout-topbar-button w-auto" type="button" style={{borderRadius: '10px', padding: '0 8px'}}>
              <i className="pi pi-user"/>
              <p style={{fontSize: '16px', marginTop: '10px', marginLeft: '5px'}}><b>{AppStorage.get('partyTaxId')}</b></p>
            </button>
          </StyleClass>
          <ul className="iam-topbar-menu list-none p-3 m-0 border-round shadow-2 hidden absolute surface-overlay origin-top w-full md:w-16rem sm:w-12rem mt-2 right-0 top-auto">
            <li>
              <Link to="/tai-khoan/thong-tin" className="p-ripple flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer">
                <i className="pi pi-id-card mr-3"></i>
                <span>Thông tin tài khoản</span>
              </Link>
              <div className="p-ripple flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
                   onClick={changePassword}>
                <i className="pi pi-key mr-3"></i>
                <span>Đổi mật khẩu</span>
              </div>
              <hr style={{margin: '0.25rem 0'}}/>
              <div className="p-ripple flex p-2 border-round align-items-center hover:surface-hover transition-colors transition-duration-150 cursor-pointer"
                   onClick={logout}>
                <i className="pi pi-power-off mr-3"></i>
                <span>Đăng xuất</span>
              </div>
            </li>
          </ul>
        </div>
      </div>
      {/*<div ref={topbarmenuRef} className={classNames('layout-topbar-menu', {'layout-topbar-menu-mobile-active': layoutState.profileSidebarVisible})}>*/}
      {/*  <div className="house-holds">*/}
      {/*  </div>*/}

      {/*  <button className="p-link layout-topbar-button" onClick={event => menu.current.toggle(event)}>*/}
      {/*    <i className="pi pi-user"/>*/}
      {/*    <span>Profile</span>*/}
      {/*  </button>*/}
      {/*  <p style={{fontSize: '16px', marginTop: '10px'}}><b>{AppStorage.get('partyTaxId')}</b></p>*/}

      {/*  <Menu model={accountMenus} popup ref={menu}/>*/}
      {/*</div>*/}

      {renderDialogChangePassword()}
    </div>
  );
});

AppTopbar.displayName = 'AppTopbar';

export default AppTopbar;